import { useState } from "react";
import { Check, MoveHorizontal } from "lucide-react";
import { IMG } from "@/lib/content";
import { goToEstimate } from "@/lib/scroll";
import { Eyebrow, Reveal } from "./Reveal";

const POINTS = ["Dull or worn finishes re-polished", "Chips and cracks repaired", "Seams refreshed and tightened", "Deep cleaning and professional sealing"];

const Slider = () => {
  const [pos, setPos] = useState(50);
  return (
    <div data-testid="restoration-slider" className="relative aspect-[4/5] w-full overflow-hidden rounded-[2px] select-none sm:aspect-[5/4]">
      <img src={IMG.kitchen} alt="Countertop after restoration" className="absolute inset-0 h-full w-full object-cover object-[50%_65%]" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={IMG.kitchen} alt="" aria-hidden="true" className="ks-before absolute inset-0 h-full w-full object-cover object-[50%_65%]" />
        <div className="ks-before-haze absolute inset-0" />
      </div>
      <span className="absolute left-4 top-4 rounded-full bg-[#0B0F17]/80 px-3 py-1 text-[11px] uppercase tracking-[0.2em] text-[#ECE6DA]">Before</span>
      <span className="absolute right-4 top-4 rounded-full bg-[#CDA85B] px-3 py-1 text-[11px] uppercase tracking-[0.2em] text-[#0B0F17]">After</span>
      <div className="pointer-events-none absolute inset-y-0 w-px bg-[#CDA85B]" style={{ left: `${pos}%` }}>
        <span className="absolute left-1/2 top-1/2 grid h-12 w-12 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full border border-[#CDA85B] bg-[#0B0F17]/80 text-[#CDA85B] backdrop-blur"><MoveHorizontal className="h-5 w-5" /></span>
      </div>
      <input
        type="range" min="0" max="100" value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Drag to compare before and after restoration"
        data-testid="restoration-slider-input"
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
      />
      <span className="absolute bottom-3 left-4 text-[11px] text-[#ECE6DA]/80">Illustrative preview · real before/after photos coming soon</span>
    </div>
  );
};

export const Restoration = () => (
  <section id="restoration" data-testid="restoration-section" className="relative overflow-hidden bg-[#0B0F17] py-24 lg:py-36">
    <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-7"><Slider /></Reveal>
      <div className="lg:col-span-5">
        <Reveal><Eyebrow>Countertop Restoration · Available now</Eyebrow></Reveal>
        <Reveal delay={0.1}><h2 className="mt-5 font-display text-4xl leading-[1.05] text-[#F5F0E6] sm:text-5xl lg:text-6xl">Love your stone <span className="italic text-[#CDA85B]">again.</span></h2></Reveal>
        <Reveal delay={0.2}><p className="mt-6 text-[#C4C1B9]">Before you replace, restore. We bring dull, stained or damaged granite, marble and quartz surfaces back to a showroom finish, often in a single visit.</p></Reveal>
        <ul className="mt-8 space-y-3">
          {POINTS.map((p, i) => (
            <Reveal as="li" key={p} delay={0.25 + i * 0.06} className="flex items-center gap-3 text-[#ECE6DA]">
              <span className="grid h-6 w-6 place-items-center rounded-full border border-[#CDA85B]/50"><Check className="h-3.5 w-3.5 text-[#CDA85B]" /></span>{p}
            </Reveal>
          ))}
        </ul>
        <Reveal delay={0.5}>
          <p data-testid="restoration-returning-discount" className="mt-8 border-l-2 border-[#CDA85B] pl-4 text-sm text-[#ECE6DA]">Returning customers get a discount on their restoration.</p>
          <button onClick={() => goToEstimate({ project_type: "Countertop restoration" })} data-testid="restoration-cta-btn" className="ks-btn-gold mt-8">Book a Restoration Estimate</button>
        </Reveal>
      </div>
    </div>
  </section>
);
